import { Condition } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/Condition';
export class ConditionViewModel extends Condition {
    static $inject = ['init'];
    constructor(init) {
        super();
        Object.assign(this, init);
    }
}
